<template>
    <div class="not-found-page vh-100 d-flex align-items-center justify-content-center">
        <div class="text-center">
            <h1 class="fw-600 text-dark mb-3">404</h1>
            <h2 class="fw-600 text-dark mb-3">{{ $t('페이지를 찾을 수 없습니다.') }}</h2>
            <p class="text-muted mb-4 f-110">
                {{ $t('주소가 잘못되었거나 이동된 페이지입니다.') }}
            </p>
            <b-button variant="primary" @click="$router.replace('/')">
                {{ $t('처음 화면으로 이동') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFoundPage',
};
</script>

<style scoped>
.not-found-page {
    background-color: #f8f9fa;
}
</style>
